import { render, staticRenderFns } from "./detailReferralChain.vue?vue&type=template&id=2dd4fbb6&scoped=true"
import script from "./detailReferralChain.vue?vue&type=script&lang=js"
export * from "./detailReferralChain.vue?vue&type=script&lang=js"
import style0 from "./detailReferralChain.vue?vue&type=style&index=0&id=2dd4fbb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd4fbb6",
  null
  
)

export default component.exports